import { render, staticRenderFns } from "./MediaCarousel.vue?vue&type=template&id=30606b61&"
import script from "./MediaCarousel.vue?vue&type=script&lang=js&"
export * from "./MediaCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports